// Hard coded values for the example presentation at mentimeter.com/how-to,
// mentimeter.com/features and Mentimeter Academy marketing experiment
export const formattedExampleVoteCode = '65 79 30';

export const isExamplePresentation = (seriesId: string) =>
  seriesId === '6cf719702669c8b0a4d4bf36bc2bd183';

const ACADEMY_PRESENTATIONS = [
  // Menti Academy
  'a8c7574ed51ff2ee79343be2126be3d5',
  '1f8bec26d8ea9ad179eeca8e5cc36c98',
  '7b8a234957cca8c4860fb490e051c314',
  'f0a589e924a76e8e5b23548780eb83b2',
  '3e92d9a5f14dc72f4eaba75d85acfbcf',
  '9d1a67e053692ad62a6a7f30473de050',
  '8665df7f47d62d8138a4f2c19a5e8725',
  'blummpmqm9ktu5u3vsfrp2webiihzuxr',
  'bleeqhsppi9jhfais34cgjeo638omy8f',
  'blihizaoxkg9myaaipqz3qybo9p9ri96',
  'bl7n4kj1pxzxynxpi2qe7pad3aby3c6q',
];
export const isAcademyPresentation = (seriesId: string) =>
  ACADEMY_PRESENTATIONS.includes(seriesId);
